<template>
  <div></div>
</template>

<script lang="ts">
import { Vue, Prop, Component } from 'vue-property-decorator';
import { Content } from '@forchange/storytime';
import { Environment } from '@/store/modules/common/types';
import { namespace } from 'vuex-class';

const common = namespace('common');

@Component({})
export default class TurnOnCamera extends Vue {
  @Prop({ type: Object }) content!: Content;
  @common.State('environment') environment!: Environment;
  @common.Action turnOnCamera!: () => void;
  chunks: any[] = [];
  url = '';

  mounted() {
    if (window.storyteller.topContet?.$kind === 'TurnOnCamera') {
      this.turnOnCamera();
      window.next();
    }
  }
}
</script>
